// const homeIcon =
//   '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.4088 7.2309L12.7197 1.13166C11.7368 0.351947 10.3714 0.351947 9.38841 1.13166L1.69939 7.2309C1.02217 7.7681 0.625 8.6014 0.625 9.48511V18.6242C0.625 20.1921 1.85176 21.4632 3.36505 21.4632H18.7431C20.2564 21.4632 21.4832 20.1921 21.4832 18.6242V9.48511C21.4832 8.6014 21.086 7.7681 20.4088 7.2309Z" fill="#C8C9C9"/><rect x="4.30469" y="17.0801" width="13.4928" height="1.94111" rx="0.970556" fill="white" /></svg>';
// const findWorks =
//   '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.51274 3.94327V5.96436L3.53881 6.16078C2.86066 6.22744 2.2204 6.56991 1.7204 7.13343C1.22039 7.69695 0.889504 8.44898 0.780654 9.26927C0.732878 9.63648 0.687434 10.0037 0.647815 10.3723C0.638383 10.4615 0.594217 10.8552 0.629611 10.934C0.665005 11.0127 0.778129 10.7725 0.844743 10.8107L0.934467 10.8619C7.26062 14.5198 14.8359 14.5198 21.1609 10.8619L21.2506 10.8107C21.317 10.7723 21.4343 11.0127 21.4695 10.934C21.5046 10.8552 21.4559 10.4613 21.4464 10.3723C21.4069 10.0039 21.363 9.63615 21.3147 9.26927C21.2059 8.44898 20.875 7.69695 20.375 7.13343C19.875 6.56991 19.2347 6.22744 18.5566 6.16078L16.5826 5.96578V3.94469C16.5828 3.34812 16.4076 2.77131 16.0889 2.31917C15.7703 1.86703 15.3294 1.56959 14.8464 1.48096L13.4248 1.22049C11.8489 0.93171 10.2465 0.93171 8.67058 1.22049L7.24897 1.48096C6.76617 1.56956 6.32543 1.86678 6.00682 2.31863C5.68822 2.77047 5.5129 3.34694 5.51274 3.94327ZM13.165 3.33125C11.7613 3.0741 10.3341 3.0741 8.93043 3.33125L7.50882 3.59172C7.43985 3.60432 7.37687 3.64674 7.33132 3.71125C7.28578 3.77576 7.26069 3.85809 7.26062 3.94327V5.81491C9.78327 5.6384 12.3121 5.6384 14.8348 5.81491V3.94327C14.8347 3.85809 14.8096 3.77576 14.7641 3.71125C14.7185 3.64674 14.6555 3.60432 14.5866 3.59172L13.165 3.33125Z" fill="#C8C9C9"/><path d="M21.4695 10.934C21.4672 10.8945 21.456 10.8562 21.4368 10.8225C21.4176 10.7887 21.391 10.7603 21.3593 10.7399C21.3276 10.7195 21.2918 10.7077 21.2548 10.7053C21.2179 10.703 21.1809 10.7103 21.1472 10.7266C14.7807 13.7363 7.31834 13.7363 0.951877 10.7266C0.918146 10.7103 0.881216 10.703 0.844264 10.7053C0.807311 10.7077 0.771442 10.7195 0.73974 10.7399C0.708038 10.7603 0.681452 10.7887 0.662269 10.8225C0.643085 10.8562 0.631878 10.8945 0.629611 10.934C0.512821 13.2696 0.630435 15.6119 0.980447 17.9208C1.0872 18.6239 1.4117 19.2685 1.90207 19.7516C2.39244 20.2346 3.02035 20.5281 3.68542 20.5853L5.82472 20.7707C9.30222 21.0696 12.7957 21.0696 16.2744 20.7707L18.4137 20.5865C19.0789 20.5293 19.7069 20.2356 20.1973 19.7523C20.6877 19.269 21.0121 18.6242 21.1186 17.9208C21.4683 15.6089 21.5872 13.2654 21.4695 10.934Z" fill="#C8C9C9"/><path d="M17.8516 10.7188C17.8516 10.7188 13.7448 11.2814 11.0499 11.2814C8.3549 11.2814 4.24817 10.7188 4.24817 10.7188" stroke="white" stroke-width="1.5" stroke-linecap="round"/></svg>';
// const findTalent =
//   '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.7719 11.9672C13.8504 11.9672 9.99687 13.2246 9.99687 15.7257V19.2739C9.99687 20.0471 10.6237 20.6739 11.3969 20.6739H20.1469C20.9201 20.6739 21.5469 20.0471 21.5469 19.2739V15.7257C21.5469 13.2246 17.6934 11.9672 15.7719 11.9672ZM7.89687 10.6005C4.13085 10.6005 0.546875 12.1996 0.546875 15.384V19.2657C0.546875 20.0389 1.17368 20.6657 1.94687 20.6657H6.49687C7.27007 20.6657 7.89687 20.0389 7.89687 19.2657V15.7257C7.89687 14.564 8.29962 12.6748 10.9257 11.4945C10.9257 11.4945 9.99687 10.6005 7.89687 10.6005Z" fill="#C8C9C9"/><path d="M12.0025 5.14541C12.0025 7.25472 10.2926 8.96465 8.1833 8.96465C6.07399 8.96465 4.36406 7.25472 4.36406 5.14541C4.36406 3.0361 6.07399 1.32617 8.1833 1.32617C10.2926 1.32617 12.0025 3.0361 12.0025 5.14541Z" fill="#C8C9C9"/><path d="M18.3698 8.62956C18.3698 10.0004 17.2585 11.1117 15.8877 11.1117C14.5169 11.1117 13.4056 10.0004 13.4056 8.62956C13.4056 7.25872 14.5169 6.14743 15.8877 6.14743C17.2585 6.14743 18.3698 7.25872 18.3698 8.62956Z" fill="#C8C9C9"/></svg>';
// const myProject =
//   '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.8169 18.7229C12.3013 20.1465 9.79786 20.1465 8.28223 18.7229C4.0769 14.773 0.648438 11.0561 0.648438 7.79548C0.648438 4.55374 3.16551 2.02539 6.36906 2.02539C8.17886 2.02539 9.91585 2.87517 11.0496 4.20753C12.1833 2.87517 13.9203 2.02539 15.7301 2.02539C18.9336 2.02539 21.4507 4.55374 21.4507 7.79548C21.4507 11.0561 18.0222 14.773 13.8169 18.7229Z" fill="#C8C9C9"/><path d="M5.28906 10.0957C5.28906 10.0957 8.67394 11.7197 11.0478 11.7197C13.4217 11.7197 16.8066 10.0957 16.8066 10.0957" stroke="white" stroke-width="1.5" stroke-linecap="round"/></svg>';

import { AiFillHeart, AiFillHome } from "react-icons/ai";
import { BsBriefcaseFill } from "react-icons/bs";
import { HiUsers } from "react-icons/hi";

export const headerTabs = [
  {
    title: "Home",
    id: "1",
    path: "/home",
    key: "home_menu",
    slug_name: "home",
    is_authenticated: false,
    responsiveIcon: AiFillHome,
  },
  {
    title: "Find Works",
    id: "2",
    path: "/find-works",
    key: "finnd_project_link",
    slug_name: "work",
    is_authenticated: true,
    responsiveIcon: BsBriefcaseFill,
  },
  {
    title: "Find Talent",
    id: "3",
    path: "/find-talent",
    key: "find_talent_menu",
    is_authenticated: true,
    slug_name: "user",
    responsiveIcon: HiUsers,
  },
  {
    title: "My Projects",
    id: "4",
    path: "/my-posted-projects",
    is_authenticated: true,
    key: "my_works_button",
    slug_name: "myworks",
    responsiveIcon: AiFillHeart,
  },
  {
    title: "About Us",
    id: "5",
    path: "/home/about",
    key: "menu_aboutus",
    is_authenticated: false,
    slug_name: "aboutus",
    responsiveIcon: HiUsers,
  },
  {
    title: "Jobs Gateway",
    id: "6",
    path: "/home/jobs-gateway",
    key: "menu_jobs",
    is_authenticated: false,
    slug_name: "jobsgateway",
    responsiveIcon: HiUsers,
  },
  {
    title: "Experts",
    id: "7",
    path: "/home/expert",
    key: "home_Menuexpert",
    is_authenticated: false,
    slug_name: "expert",
    responsiveIcon: HiUsers,
  },
  {
    title: "Contact Us",
    id: "8",
    path: "/home/contactus",
    key: "Contact Us",
    is_authenticated: true,
    slug_name: "contactus",
    responsiveIcon: HiUsers,
  },
];
export const authHeaderTabs = [
  {
    title: "Home",
    id: "1",
    path: "/home",
    key: "home_menu",
    slug_name: "home",
    is_authenticated: false,
    responsiveIcon: AiFillHome,
  },
  {
    title: "Find Works",
    id: "2",
    path: "/find-works",
    key: "finnd_project_link",
    slug_name: "work",
    is_authenticated: false,
    responsiveIcon: BsBriefcaseFill,
  },
  {
    title: "Find Talent",
    id: "3",
    path: "/find-talent",
    key: "find_talent_menu",
    is_authenticated: false,
    slug_name: "user",
    responsiveIcon: HiUsers,
  },
  {
    title: "My Projects",
    id: "4",
    path: "/my-posted-projects",
    is_authenticated: true,
    key: "my_works_button",
    slug_name: "myworks",
    responsiveIcon: AiFillHeart,
  },
];
 export const unauthHeaderTabs = [
  {
    title: "Home",
    id: "1",
    path: "/home",
    key: "home_menu",
    slug_name: "home",
    is_authenticated: false,
    responsiveIcon: AiFillHome,
  },
  {
    title: "About Us",
    id: "2",
    path: "/home/about",
    key: "menu_aboutus",
    is_authenticated: false,
    slug_name: "aboutus",
    responsiveIcon: HiUsers,
  },
  {
    title: "Jobs Gateway",
    id: "3",
    path: "/home/jobs-gateway",
    key: "menu_jobs",
    is_authenticated: false,
    slug_name: "jobsgateway",
    responsiveIcon: HiUsers,
  },
  {
    title: "Experts",
    id: "4",
    path: "/home/expert",
    key: "Home_Menuexpert",
    is_authenticated: false,
    slug_name: "expert",
    responsiveIcon: HiUsers,
  },
  {
    title: "Contact Us",
    id: "6",
    path: "/home/contactus",
    key: "Contactus_Home",
    is_authenticated: false,
    slug_name: "contactus",
    responsiveIcon: HiUsers,
  },
];